import React, {Fragment} from 'react'
import {Nullable} from '../../../../Common/TypeHelper'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'
import {ConfirmContent} from '../../Molecules/BaseContentBlocks/ConfirmContent'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'
import {MBContentBodyDivider} from '../../Atoms/Dividers'
import {useTranslation} from 'react-i18next'


type Props = {
  title: string
  topMessage: string[]
  mail: string
  familyName: string
  firstName: string
}

export function RegisteredMemberInfoContents(props: Props): JSX.Element {
  const {t} = useTranslation('member')

  const displayTopMessage = (): Nullable<JSX.Element> => {
    if (props.topMessage.length === 0) {
      return null
    }

    return <ContentTopMessage data-testid={'basic-info-top-message'}>
      {props.topMessage?.map((message, i) => {
        return <Fragment key={i}>{message}<br/></Fragment>
      })}
    </ContentTopMessage>
  }

  return (
    <ContentBlock data-testid={'block-registered-information'}>
      <PIMStack spacing={'18px'}>
        <ContentTitle noMarginBottom={true}>{props.title}</ContentTitle>
        <PIMStack spacing={'18px'} divider={<MBContentBodyDivider/>} showEndDivider>
          {displayTopMessage()}
          <ConfirmContent
            label={'お名前'} values={[`${props.familyName} ${props.firstName} さん`]}
          />
          <ConfirmContent
            label={t('新規登録完了.登録情報.ラベル メールアドレス')} values={[props.mail]}
          />
        </PIMStack>
      </PIMStack>
    </ContentBlock>
  )
}
